<script setup lang="ts">
import Spinner from '@autobid/ui/components/common/Spinner.vue'
</script>

<template>
  <div class="flex h-full w-full items-center justify-center py-4">
    <Spinner class="mr-2" />
  </div>
</template>
